import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { DASHBOARD_WIDGET_SPACING } from '../../../../../constants/dashboardWidgetSpacing'
import { getImgPath } from '../../../../../utils/getImgPath'

export const AnnualReportsBanner = styled.div`
  width: 100%;
  height: 120px;
  margin: ${DASHBOARD_WIDGET_SPACING / 2}px 0;
  padding: ${Spacing.S16} ${Spacing.S24} ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  position: relative;
  background-color: ${Color.Lavender100};
  background-image: url('${getImgPath('/annual-reports/banner-annual-reports.png')}');
  background-position: top -50px right 80px;
  background-repeat: no-repeat;
  background-size: auto 220%;
  overflow: hidden;
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  margin-top: ${Spacing.S6};
`
export const TextWrapper = styled.div`
  margin-right: ${Spacing.S24};
`

export const ContinueWrapper = styled(TextWrapper)`
  align-self: center;
`

export const ButtonWrapper = styled.div`
  margin-top: ${Spacing.S4};
`
export const CloseIconWrapper = styled.div`
  position: absolute;
  top: ${Spacing.S8};
  right: ${Spacing.S8};
`
